import React from 'react';
import { StyledIntro } from './Intro.styled';

const MainTile = props => (
    <StyledIntro style={{ backgroundImage: `url(${props.image})` }} className="hero">
        <div>Hello, my name is <span>Sean</span>. I am a <span>Front End Developer</span> with a passion for <span>UX</span>.</div>
    </StyledIntro>
)

export default MainTile;